<!-- <button type="button"
*ngIf="_currentConfig!=undefined && _currentConfig.deleteTable!=undefined && !_currentConfig.deleteTable"
class="primary-btn" (click)="openConfig('dynamic_table_config');">Create Table</button>
<button type="button"
  *ngIf="_currentConfig!=undefined && _currentConfig.deleteTable!=undefined && _currentConfig.deleteTable"
class="primary-btn" (click)="deleteTable();">Delete Table</button> -->

@if (editableGridConfig!=undefined && editableGridConfig && editableGridConfig.json !=undefined && editableGridConfig.json && editableGridConfig.config!=undefined) {
  <div
    >
    <dhs-editable-grid #temp [config]="editableGridConfig.config" [json]="editableGridConfig.json"
      (listen_changes)="listen_changes($event,temp)">
    </dhs-editable-grid>
  </div>
}